import {
  RecaptchaFormsModule,
  RecaptchaModule,
  RecaptchaSettings,
  RECAPTCHA_LANGUAGE,
  RECAPTCHA_SETTINGS
} from 'ng-recaptcha';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FormatDatePipe } from './pipes/date-format.pipe';
import { environment } from '../../environments/environment';
import { MaterialModule } from './../material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoaderComponent } from './components/loader/loader.component';
import { FormatDateSwedishPipe } from './pipes/format-date-swedish.pipe';
import { DdlSelectComponent } from './components/ddl-select/ddl-select.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { SearchItemComponent } from './components/search-item/search-item.component';
import { CounterBrfComponent } from './components/counters-brf/counter-brf.component';
import { SuccessDialogComponent } from './modals/success-dialog/success-dialog.component';
import { ContactusDialogComponent } from './modals/contact-us/contactus-dialog.component';
import { ConfirmDialogComponent } from './modals/confirm-dialog/confirm-dialog.component';
import { SendEmailDialogComponent } from './modals/send-email/send-email-dialog.component';
import { ExposureSmallComponent } from './components/exposure-small/exposure-small.component';
import { SubscribeDialogComponent } from './modals/subscribe-dialog/subscribe-dialog.component';
import { ExposureBannerComponent } from './components/exposure-banner/exposure-banner.component';
import { ExposureMediumComponent } from './components/exposure-medium/exposure-medium.component';
import { SearchSupplierComponent } from './components/search-supplier-widget/search-supplier.component';
import { MediumNewsComponent } from './components/news/medium-news-widget/medium-news-widget.component';
import { BrfListSupplierWidgetComponent } from './components/list-suppliers-widget/list-suppliers-widget.component';
import { NewsDetailMediaCarouselComponent } from './components/news-detail-media-carousel/news-detail-media-carousel.component';
import { SubscribeOfferNewsletterDialogComponent } from './modals/subscribe-offer-newsletter/subscribe-offer-newsletter.component';
import { SuppliersSearchResultTileComponent } from './components/suppliers-search-result-tile/suppliers-search-result-tile.component';

@NgModule({
  declarations: [
    BreadcrumbComponent,
    LoaderComponent,
    ConfirmDialogComponent,
    SearchItemComponent,
    FormatDatePipe,
    FormatDateSwedishPipe,
    ContactusDialogComponent,
    SubscribeDialogComponent,
    SendEmailDialogComponent,
    CounterBrfComponent,
    SearchSupplierComponent,
    DdlSelectComponent,
    SuccessDialogComponent,
    ExposureBannerComponent,
    ExposureMediumComponent,
    ExposureSmallComponent,
    MediumNewsComponent,
    BrfListSupplierWidgetComponent,
    NewsDetailMediaCarouselComponent,
    SuppliersSearchResultTileComponent,
    SubscribeOfferNewsletterDialogComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MaterialModule,
    TranslateModule,
    RouterModule,
    RecaptchaModule,
    RecaptchaFormsModule
  ],
  exports: [
    BreadcrumbComponent,
    LoaderComponent,
    ReactiveFormsModule,
    FormsModule,
    MaterialModule,
    TranslateModule,
    RouterModule,
    ConfirmDialogComponent,
    SearchItemComponent,
    FormatDatePipe,
    FormatDateSwedishPipe,
    ContactusDialogComponent,
    SubscribeDialogComponent,
    SendEmailDialogComponent,
    CounterBrfComponent,
    SearchSupplierComponent,
    DdlSelectComponent,
    MediumNewsComponent,
    SuccessDialogComponent,
    ExposureBannerComponent,
    ExposureMediumComponent,
    ExposureSmallComponent,
    BrfListSupplierWidgetComponent,
    NewsDetailMediaCarouselComponent,
    SuppliersSearchResultTileComponent
  ],
  providers: [
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.reCaptchaSiteKey
      } as RecaptchaSettings
    },
    {
      provide: RECAPTCHA_LANGUAGE,
      useValue: 'sv' // use French language
    }
  ]
})
export class SharedModule {}
